import { Grid, GridCellProps, GridColumn } from "@progress/kendo-react-grid";
import { useDealContext } from "src/dm/components/DealLayout/DealLayout";
import { useDealSignatures } from "src/dm/hooks/useDealActivity";
import UserName from "src/dm/components/UserName/UserName";

const fmtWhen = (iso: string | null): string => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString();
};

const DealSignaturesPage = () => {
  const deal = useDealContext();
  const { data, isLoading, isError, error } = useDealSignatures(deal.dealId);

  if (isLoading) return <p>Loading signatures…</p>;
  if (isError)
    return (
      <p style={{ color: "#b91c1c" }}>
        {error instanceof Error ? error.message : "Failed to load"}
      </p>
    );

  const rows = (data ?? []).map((r) => ({ ...r, takenDate: fmtWhen(r.takenDate) }));

  // Custom cell for the "By" column — renders the signer's DOMAIN\username
  // through the shared <UserName> resolver per audit/21-visual-diff §12,
  // so signatures grids display "Anna Approver" instead of a raw id.
  const TakenByCell = (props: GridCellProps) => {
    const row = props.dataItem as { takenBy: string | null };
    return (
      <td>
        <UserName userId={row.takenBy} />
      </td>
    );
  };

  return (
    <div>
      <h2 style={{ marginTop: 0 }}>Signatures</h2>
      {rows.length === 0 ? (
        <p style={{ color: "#94a3b8" }}>No sign-offs yet.</p>
      ) : (
        <Grid data={rows}>
          <GridColumn field="signatureId" title="#" width="100px" />
          <GridColumn field="action" title="Action" width="180px" />
          <GridColumn field="takenBy" title="By" width="220px" cells={{ data: TakenByCell }} />
          <GridColumn field="takenDate" title="When" />
        </Grid>
      )}
    </div>
  );
};

export default DealSignaturesPage;
